import React from 'react';
import { bool, shape, string } from 'prop-types';

const Water2 = ({
  className = 'icon',
  notUseClass = false,
  style = { color: 'currentColor' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M12 19C9.23858 19 7 16.7614 7 14C7 13.3893 7.37553 12.0262 7.97841 11.0542C8.90046 9.56752 10.2444 7.9156 11.4004 6.59761C11.6098 6.35881 11.8111 6.13327 12 5.92421C12.1889 6.13327 12.3902 6.35881 12.5996 6.59761C13.7556 7.9156 15.0995 9.56752 16.0216 11.0542C16.6245 12.0262 17 13.3893 17 14C17 16.7614 14.7614 19 12 19ZM13.3709 4.45855C14.6326 5.84727 16.4896 8.01422 17.7212 10C18.479 11.2217 19 12.9453 19 14C19 17.866 15.866 21 12 21C8.13401 21 5 17.866 5 14C5 12.9453 5.52102 11.2217 6.27877 10C7.51041 8.01422 9.36744 5.84727 10.6291 4.45855C11.4364 3.56996 12 3 12 3C12 3 12.5636 3.56996 13.3709 4.45855Z" fill="currentColor" />
  </svg>
);

Water2.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Water2;
